import React, { useEffect, useState } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import { history } from "../../index";
import {
  GeneralHeader,
  SubheaderComponent,
  useWindowDimensions,
} from "../common";
import Grid from "@material-ui/core/Grid";
import { fontSize } from "../../styles";
import tick from "../../images/tick_icon.png";
import Paper from "@material-ui/core/Paper";
import user from "../../images/user_icon.png";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { withStyles } from "@material-ui/core/styles";
import InputBase from "@material-ui/core/InputBase";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import { getOptions } from "../../service/api/option";
import { useSelector } from "react-redux";
import male_icon from "../../images/male_head.jpg";
import female_icon from "../../images/female_head.jpg";
import { queryList } from "../../service/api/common";

const useStyles = makeStyles((theme) => ({
  text: {
    fontSize: 20,
    [theme.breakpoints.down("sm")]: {
      fontSize: 15,
    },
  },
  canvas: {
    paddingTop: 30,
  },
  gridItem: {
    marginLeft: 10,
    marginRight: 10,
  },
  leftPaper: {
    borderRadius: 10,
    minHeight: 390,
    backgroundColor: "#457B9D",
    padding: 15,
    marginBottom: 20,
  },
  rightPaper: {
    borderRadius: 10,
    height: "95%",
    minHeight: 390,
    backgroundColor: "#457B9D",
    padding: 15,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: 20,
  },
  case: {
    minHeight: 270,
    backgroundColor: "#E5E5E5",
    padding: 15,
    marginBottom: 10,
  },
  textList: {
    minHeight: "200px",
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
    width: "60%",
    [theme.breakpoints.down("sm")]: {
      width: "90%",
    },
  },
  leftTitle: {
    fontSize: 21,
    marginBottom: 7,
    color: "white",
  },
  caseDescription: {
    fontSize: 20,
    marginBottom: 7,
    [theme.breakpoints.down("sm")]: {
      fontSize: fontSize.h4,
    },
    color: "black",
  },
  select: {
    width: 400,
    marginBottom: 10,
    maxHeight: 100,
    overflowY: "auto",
    [theme.breakpoints.down("sm")]: {
      width: "60vw",
    },
  },
  caseContents: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },
  imgHolder: {
    minWidth: "40%",
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("xs")]: {
      marginBottom: 10,
    },
  },
  iconImg: {
    borderRadius: "50%",
    borderStyle: "solid",
    borderColor: "white",
    borderWidth: "3px",
    height: 150,
    width: 150,
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    [theme.breakpoints.down("xs")]: {
      height: 120,
      width: 120,
    },
  },
  textTitle: {
    fontSize: 17,
    fontWeight: "bold",
  },
  textDetails: {
    fontSize: 17,
    paddingRight: 10,
    letterSpacing: "0.5px",
    marginBottom: 10,
    [theme.breakpoints.down("sm")]: {
      marginBottom: 5,
    },
  },
  boardList: {
    padding: 0,
    display: "flex",
    flexDirection: "column",
    minHeight: 320,
    width: "100%",
    overflowY: "auto",
  },
  userRow: {
    padding: 0,
    display: "flex",
    flexDirection: "row",
    color: "white",
    borderStyle: "solid",
    borderColor: "#E4E4E4",
    borderWidth: "0px 0px 0.5px 0px",
  },
  user: {
    marginRight: 10,
    fontSize: fontSize.h3,
  },
  bg: {
    height: "100vh",
    width: "100vw",
    paddingTop: 120,
    position: "fixed",
    backgroundColor: "#E5E5E5",
    zIndex: -2,
  },
}));

function Leaderboard() {
  const classes = useStyles();
  const [openUser, setOpenUser] = useState(false);
  const [selectedStage, setSelectedStage] = useState({
    id: "all",
    name: "All Users",
  });
  const [stages, setStages] = useState([]);
  const [selectedCase, setSelectedCase] = useState({
    id: "",
    name: "None",
    block: "None",
    presentation: "None",
  });
  const [cases, setCases] = useState([]);
  const [users, setUsers] = useState([]);

  const caseStage = useSelector((state) => state.gameStates.selectedStage);

  useEffect(() => {
    // get stage options
    getOptions("stage").then((d) => {
      setStages([{ id: "all", name: "All Users" }, ...d]);
    });
  }, []);

  useEffect(() => {
    // get cases by the selected stage
    queryList("kases", `query=status:active$stageId:${caseStage.id}`).then(
      ({ data }) => {
        setCases(data);
        if (data.length > 0) setSelectedCase(data[0]);
      }
    );
  }, [caseStage]);

  useEffect(() => {
    if (
      !selectedCase ||
      !selectedCase.id ||
      !selectedStage ||
      !selectedStage.id
    ) {
      setUsers([]);
      return;
    }
    // get cases by the selected stage
    queryList(
      "rank",
      `caseId=${selectedCase.id}&num=10&userStage=${selectedStage.id}`
    ).then(({ data }) => {
      setUsers(data);
    });
  }, [selectedCase, selectedStage]);

  const navigateCases = () => {
    history.push("/cases");
  };

  const subHeaderTab1 = {
    collapse: false,
    img: { src: tick, alt: "Stage" },
    text: (
      <Typography className={classes.text}>
        {caseStage.name.toUpperCase()}
      </Typography>
    ),
  };

  const subHeaderTab2 = {
    collapse: true,
    img: { src: user, alt: "User" },
    text: (
      <Typography className={classes.text}>
        {selectedStage.name.toUpperCase()}
      </Typography>
    ),
    list: stages,
    onClick: setSelectedStage,
    open: openUser,
    setOpen: setOpenUser,
  };

  const BootstrapInput = withStyles((theme) => ({
    root: {
      "label + &": {
        marginTop: theme.spacing(3),
        color: "black",
      },
    },
    input: {
      borderRadius: 4,
      backgroundColor: "#E5E5E5",
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
      boxSizing: "border-box",
      position: "relative",
      fontSize: 16,
      padding: "11px 26px 11px 12px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      "&:focus": {
        backgroundColor: "#E5E5E5",
      },
    },
  }))(InputBase);

  const chooseCase = (e) => {
    for (let i = 0; i < cases.length; i++) {
      if (cases[i].id === e.target.value) {
        setSelectedCase(cases[i]);
      }
    }
  };

  const { height, width } = useWindowDimensions();

  return (
    <React.Fragment>
      <CssBaseline />
      <div
        style={{
          backgroundColor: "#E5E5E5",
          overflowY: "auto",
          marginTop: 0,
        }}
      >
        <GeneralHeader
          profile
          backArrow
          mode={"Leaderboard"}
          navigate={navigateCases}
        />
        <SubheaderComponent props={[subHeaderTab1, subHeaderTab2]} />
        <div className={classes.bg} />
        <div className={classes.canvas}>
          <Grid container direction="row" justify="center">
            <Grid item md={6} xs={10} className={classes.gridItem}>
              <Paper
                className={classes.leftPaper}
                style={{ height: width < 960 ? 510 : height - 200 }}
              >
                <Typography className={classes.leftTitle}>
                  Select Case
                </Typography>
                <FormControl>
                  <Select
                    labelId="demo-customized-select-label"
                    id="demo-customized-select"
                    value={selectedCase.id}
                    onChange={(event) => chooseCase(event)}
                    input={<BootstrapInput />}
                    className={classes.select}
                  >
                    {cases.map((choice) => (
                      <MenuItem key={choice.id} value={choice.id}>
                        {choice.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <Paper
                  className={classes.case}
                  style={{ height: width < 960 ? 390 : height - 320 }}
                >
                  <Typography className={classes.caseDescription}>
                    Case Description
                  </Typography>
                  <div className={classes.caseContents}>
                    <div className={classes.imgHolder}>
                      {selectedCase.gender ? (
                        <img
                          className={classes.iconImg}
                          src={
                            selectedCase.gender === "male"
                              ? male_icon
                              : female_icon
                          }
                          alt="Patient"
                        />
                      ) : null}
                    </div>

                    <div
                      className={classes.textList}
                      style={{
                        maxHeight:
                          width < 600 ? 200 : width < 960 ? 330 : height - 390,
                      }}
                    >
                      <Typography className={classes.textTitle}>
                        Patient Name
                      </Typography>
                      <Typography className={classes.textDetails}>
                        {selectedCase.name}
                      </Typography>

                      <Typography className={classes.textTitle}>
                        Posting
                      </Typography>
                      <Typography className={classes.textDetails}>
                        {selectedCase.block}
                      </Typography>

                      <Typography className={classes.textTitle}>
                        Case
                      </Typography>
                      <Typography className={classes.textDetails}>
                        {selectedCase.presentation}
                      </Typography>
                    </div>
                  </div>
                </Paper>
              </Paper>
            </Grid>

            <Grid item md={4} xs={10} className={classes.gridItem}>
              <Paper
                className={classes.rightPaper}
                style={{ height: width < 960 ? 510 : height - 200 }}
              >
                <Typography className={classes.leftTitle}>
                  Leaderboard
                </Typography>
                <List
                  className={classes.boardList}
                  style={{
                    height: width < 960 ? 450 : height - 250,
                  }}
                >
                  {users.map((item, index) => (
                    <List className={classes.userRow} key={item.id}>
                      <ListItem style={{ paddingLeft: 10, width: "300%" }}>
                        <Typography className={classes.user}>
                          {(index + 1).toString() + ". "}
                        </Typography>
                        <Typography className={classes.user}>
                          {!!item.userNickname
                            ? item.userNickname
                            : item.userName}
                        </Typography>
                      </ListItem>

                      <ListItem style={{ padding: 0 }}>
                        <Typography className={classes.user}>
                          {Math.round((item.scores + Number.EPSILON) * 100) /
                            100}
                          %
                        </Typography>
                      </ListItem>
                    </List>
                  ))}
                </List>
              </Paper>
            </Grid>
          </Grid>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Leaderboard;
